import { cn } from "@/libs/utils";
import CommonImg from "@/components/Common/Img";

interface CardProps {
  icon?: string;
  title?: string;
  noTitle?: boolean;
  noBorder?: boolean;
  children: React.ReactNode;
  className?: string;
  headerActions?: React.ReactNode;
  trailingActions?: React.ReactNode;
}

export default function Card({
  icon = "",
  title = "",
  noTitle = false,
  noBorder = false,
  children,
  className = "",
  headerActions,
  trailingActions,
}: CardProps) {
  return (
    <div className="w-full bg-white rounded-xl border-[1px] border-gray-D">
      {!noTitle && (
        <div className="flex justify-between items-center p-5 pb-4">
          <div className="flex gap-2 items-center">
            <CommonImg src={icon} alt={title} />
            <span className="text-sm text-gray-A font-semibold">{title}</span>
            {trailingActions && <>{trailingActions}</>}
          </div>
          {headerActions && <div>{headerActions}</div>}
        </div>
      )}
      <div
        className={cn(
          "min-h-[280px]  border-gray-D",
          {
            "border-t-[1px]": !noBorder,
          },
          className
        )}
      >
        {children}
      </div>
    </div>
  );
}

type HeaderItemCardProps = {
  title: string;
  value: string;
  className?: string;
};

export function HeaderItemCard({
  title,
  value,
  className,
}: HeaderItemCardProps) {
  return (
    <div className="flex flex-col gap-[10px] p-5 bg-white border-gray-D border-[1px] rounded-xl">
      <p className="text-sm text-gray-B font-semibold">{title}</p>
      <p
        className={cn(
          "text-2xl text-dark-brown font-bold text-right",
          className
        )}
      >
        {value}
      </p>
    </div>
  );
}
